function printProductCard() {

  /* =========================================================
     HELPERS
     ========================================================= */

  const escapeHtml = (value) => {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const hasContent = (element) => {
    if (!element) return false;

    return (
      element.textContent.trim() !== '' ||
      element.querySelector('img, a, table, ul, ol')
    );
  };


  /* =========================================================
     PRODUCT ELEMENTS
     ========================================================= */

  const titleElement =
    document.querySelector('.product__title h1') ||
    document.querySelector('h1');

  const skuElement =
    document.querySelector('[id^="Sku-"]') ||
    document.querySelector('.product__sku');

  const descriptionElement =
    document.querySelector('.print-product-description');

  const regnoteElement =
    document.querySelector('.print-regnote');

  const regulatoryElement =
    document.querySelector('.print-regulatory');

  const safetyLinkElement =
    document.querySelector('.print-safety-link');

  const imageElement =
    document.querySelector('.product__media-list img') ||
    document.querySelector('.product__media img');


  /* =========================================================
     TITLE
     ========================================================= */

  const title = titleElement
    ? titleElement.textContent.trim()
    : '';


  /* =========================================================
     PRICE

     Use only the actual selling price.
     This avoids Dawn labels such as:
     Normaler Preis
     Verkaufspreis
     Sale
     Ausverkauft
     ========================================================= */

  const salePriceElement =
    document.querySelector(
      '[id^="price-"] .price__sale .price-item--sale'
    );

  const regularPriceElement =
    document.querySelector(
      '[id^="price-"] .price__regular .price-item--regular'
    );

  let price = '';

  if (
    salePriceElement &&
    salePriceElement.offsetParent !== null
  ) {
    price = salePriceElement.textContent
      .replace(/\s+/g, ' ')
      .trim();
  } else if (regularPriceElement) {
    price = regularPriceElement.textContent
      .replace(/\s+/g, ' ')
      .trim();
  }


  /* =========================================================
     UNIT PRICE
     ========================================================= */

  const unitPriceElement =
    document.querySelector('[id^="price-"] .unit-price');

  const unitPrice = unitPriceElement
    ? unitPriceElement.textContent
        .replace(/\s+/g, ' ')
        .trim()
    : '';


  /* =========================================================
     SKU
     ========================================================= */

  let sku = skuElement
    ? skuElement.textContent
        .replace(/\s+/g, ' ')
        .trim()
    : '';

  sku = sku.replace(/^SKU\s*:\s*/i, '');


  /* =========================================================
     PRODUCT DESCRIPTION / GASKET SPECS
     ========================================================= */

  const description =
    hasContent(descriptionElement)
      ? descriptionElement.innerHTML
      : '';


  /* =========================================================
     REGULATORY NOTE
     ========================================================= */

  const regnote =
    hasContent(regnoteElement)
      ? regnoteElement.innerHTML
      : '';


  /* =========================================================
     MANUFACTURER / RESPONSIBLE PERSON / SAFETY LIST
     ========================================================= */

  const regulatory =
    hasContent(regulatoryElement)
      ? regulatoryElement.innerHTML
      : '';


  /* =========================================================
     SAFETY INFORMATION LINK
     ========================================================= */

  const safetyLink =
    hasContent(safetyLinkElement)
      ? safetyLinkElement.innerHTML
      : '';


  /* =========================================================
     IMAGE
     ========================================================= */

  const image = imageElement
    ? imageElement.currentSrc || imageElement.src
    : '';


  /* =========================================================
     PRODUCT URL

     Prefer Shopify's canonical product URL so theme-preview
     and tracking parameters are not printed.
     ========================================================= */

  const canonicalElement =
    document.querySelector('link[rel="canonical"]');

  const productUrl =
    canonicalElement && canonicalElement.href
      ? canonicalElement.href
      : window.location.href.split('#')[0].split('?')[0];


  /* =========================================================
     GENERATED DATE

     Uses the currently selected storefront language/locale.
     ========================================================= */

  const pageLocale =
    document.documentElement.lang || 'en';

  const generatedDate =
    new Intl.DateTimeFormat(pageLocale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date());


  /* =========================================================
     OPEN PRINT WINDOW
     ========================================================= */

  const printWindow = window.open(
    '',
    '_blank',
    'width=900,height=700'
  );

  if (!printWindow) return;


  /* =========================================================
     PRINT DOCUMENT
     ========================================================= */

  const html = `
<!doctype html>
<html lang="${escapeHtml(pageLocale)}">

<head>

<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">

<title>Craft Hardware – ${sku ? `${escapeHtml(sku)} – ` : ''}${escapeHtml(title)}</title>

<style>

  @page {
    margin: 18mm;
  }

  * {
    box-sizing: border-box;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    background: #fff;
    color: #000;
  }

  body {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 11pt;
    line-height: 1.5;
  }

  .print-product {
    max-width: 180mm;
    margin: 0 auto;
  }


  /* =======================================================
     COMPANY MASTHEAD
     ======================================================= */

  .datasheet-header {
    text-align: center;
    margin-bottom: 7mm;
    padding-bottom: 5mm;
    border-bottom: 1px solid #bbb;
  }

  .company-name {
    font-size: 18pt;
    font-weight: 600;
    line-height: 1.2;
  }

  .company-details {
    margin-top: 2mm;
    font-size: 9pt;
    line-height: 1.45;
  }

  .datasheet-label {
    margin: 5mm 0 9mm;
    text-align: center;
    font-size: 11pt;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }


  /* =======================================================
     PRODUCT IMAGE
     ======================================================= */

  .product-image {
    margin: 0 0 10mm;
  }

  .product-image img {
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 90mm;
    object-fit: contain;
  }


  /* =======================================================
     PRODUCT TITLE
     ======================================================= */

  h1.product-title {
    margin: 0 0 5mm;
    font-size: 22pt;
    line-height: 1.2;
    font-weight: 500;
    break-after: avoid;
    page-break-after: avoid;
  }


  /* =======================================================
     PRICE
     ======================================================= */

  .price {
    margin: 0;
    font-size: 15pt;
    line-height: 1.4;
  }

  .unit-price {
    margin: 1mm 0 0;
    font-size: 11pt;
    line-height: 1.4;
  }


  /* =======================================================
     SKU
     Same size as product price
     ======================================================= */

  .sku {
    margin: 4mm 0 8mm;
    font-size: 15pt;
    line-height: 1.4;
  }


  /* =======================================================
     MAIN PRODUCT DESCRIPTION / SPECIFICATIONS
     ======================================================= */

  .description {
    margin-top: 8mm;
    font-size: 11pt;
  }

  .description > :first-child {
    margin-top: 0;
  }

  .description h1,
  .description h2,
  .description h3,
  .description h4 {
    break-after: avoid;
    page-break-after: avoid;
  }

  .description h2 {
    font-size: 16pt;
  }

  .description h3 {
    font-size: 13pt;
  }

  .description p {
    margin-top: 0;
    margin-bottom: 4mm;
  }

  .description ul,
  .description ol {
    margin-top: 2mm;
    margin-bottom: 4mm;
    padding-left: 7mm;
  }

  .description table {
    width: 100%;
    border-collapse: collapse;
    margin: 4mm 0;
  }

  .description td,
  .description th {
    padding: 1.5mm 2mm;
    vertical-align: top;
  }

  .description img {
    max-width: 100%;
    height: auto;
  }


  /* =======================================================
     REGULATORY NOTE
     ======================================================= */

  .regnote {
    margin-top: 8mm;
    padding-top: 5mm;
    border-top: 1px solid #ddd;
    font-size: 10pt;
  }

  .regnote p {
    margin: 0;
  }


  /* =======================================================
     MANUFACTURER / RESPONSIBLE / SAFETY INFORMATION
     ======================================================= */

  .regulatory {
    margin-top: 8mm;
    font-size: 10pt;
  }

  .regulatory p {
    margin: 0 0 1.5mm;
  }

  .regulatory h3 {
    margin: 5mm 0 2mm !important;
    font-size: 12pt !important;
    line-height: 1.35;
    break-after: avoid;
    page-break-after: avoid;
  }

  .regulatory ul {
    margin: 2mm 0 0;
    padding-left: 7mm;
  }

  .regulatory li {
    margin-bottom: 1mm;
  }


  /* =======================================================
     SAFETY INFORMATION LINK
     ======================================================= */

  .safety-info {
    margin-top: 6mm;
    font-size: 10pt;
  }

  .safety-info a {
    color: #000;
    text-decoration: underline;
    overflow-wrap: anywhere;
  }


  /* =======================================================
     DATASHEET FOOTER
     ======================================================= */

  .datasheet-footer {
    margin-top: 12mm;
    padding-top: 5mm;
    border-top: 1px solid #bbb;
    font-size: 8.5pt;
    line-height: 1.55;
    color: #555;
  }

  .datasheet-footer-row {
    margin: 0 0 1mm;
  }

  .datasheet-footer a {
    color: #555;
    text-decoration: none;
    overflow-wrap: anywhere;
  }

  .datasheet-disclaimer {
    margin-top: 2mm;
    font-style: italic;
  }

  .datasheet-copyright {
    margin-top: 4mm;
    padding-top: 2mm;
    border-top: 1px solid #ddd;
    font-size: 8pt;
    color: #666;
    }


  /* =======================================================
     GENERAL PRINT BEHAVIOUR
     ======================================================= */

  a[href]::after {
    content: none;
  }

  h1,
  h2,
  h3,
  h4,
  table,
  tr,
  img {
    break-inside: avoid;
    page-break-inside: avoid;
  }

</style>

</head>


<body>

<div class="print-product">


  <!-- =====================================================
       COMPANY
       ===================================================== -->

  <div class="datasheet-header">

    <div class="company-name">
      Craft Hardware
    </div>

    <div class="company-details">
      CH INOX GmbH<br>
      Kreuzeckstr. 9a · 86163 Augsburg · Germany<br>
      www.crafthardware.de
    </div>

  </div>


  <div class="datasheet-label">
    Product datasheet
  </div>


  <!-- =====================================================
       PRODUCT IMAGE
       ===================================================== -->

  ${
    image
      ? `
        <div class="product-image">
          <img
            src="${escapeHtml(image)}"
            alt="${escapeHtml(title)}"
          >
        </div>
      `
      : ''
  }


  <!-- =====================================================
       TITLE
       ===================================================== -->

  <h1 class="product-title">
    ${escapeHtml(title)}
  </h1>


  <!-- =====================================================
       PRICE
       ===================================================== -->

  ${
    price
      ? `
        <div class="price">
          ${escapeHtml(price)}
        </div>
      `
      : ''
  }


  <!-- =====================================================
       UNIT PRICE
       ===================================================== -->

  ${
    unitPrice
      ? `
        <div class="unit-price">
          ${escapeHtml(unitPrice)}
        </div>
      `
      : ''
  }


  <!-- =====================================================
       SKU
       ===================================================== -->

  ${
    sku
      ? `
        <div class="sku">
          SKU: ${escapeHtml(sku)}
        </div>
      `
      : ''
  }


  <!-- =====================================================
       DESCRIPTION / GASKET SPECS
       ===================================================== -->

  ${
    description
      ? `
        <div class="description">
          ${description}
        </div>
      `
      : ''
  }


  <!-- =====================================================
       REGULATORY NOTE
       Only inserted when present
       ===================================================== -->

  ${
    regnote
      ? `
        <div class="regnote">
          ${regnote}
        </div>
      `
      : ''
  }


  <!-- =====================================================
       MANUFACTURER / RESPONSIBLE / SAFETY LIST
       Only inserted when present
       ===================================================== -->

  ${
    regulatory
      ? `
        <div class="regulatory">
          ${regulatory}
        </div>
      `
      : ''
  }


  <!-- =====================================================
       SAFETY INFORMATION LINK
       Only inserted when present
       ===================================================== -->

  ${
    safetyLink
      ? `
        <div class="safety-info">
          ${safetyLink}
        </div>
      `
      : ''
  }


  <!-- =====================================================
       FOOTER
       ===================================================== -->

  <div class="datasheet-footer">

    <div class="datasheet-footer-row">
      <strong>Product URL:</strong>
      <a href="${escapeHtml(productUrl)}">
        ${escapeHtml(productUrl)}
      </a>
    </div>

    <div class="datasheet-footer-row">
      <strong>Generated:</strong>
      ${escapeHtml(generatedDate)}
    </div>

    <div class="datasheet-disclaimer">
      Specifications subject to change.
    </div>

    <div class="datasheet-copyright">
    © ${new Date().getFullYear()} Craft Hardware / CH INOX GmbH. All rights reserved.
    </div>

  </div>


</div>

</body>
</html>
`;


  /* =========================================================
     WRITE DOCUMENT
     ========================================================= */

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();


  /* =========================================================
     WAIT FOR ALL IMAGES

     This also handles images that might be included inside
     gasket-specs or the normal product description.
     ========================================================= */

  const doPrint = () => {
    printWindow.focus();
    printWindow.print();
  };

  const waitForImages = () => {

    const images = Array.from(
      printWindow.document.images
    );

    if (images.length === 0) {
      setTimeout(doPrint, 150);
      return;
    }

    const pendingImages =
      images.filter((img) => !img.complete);

    if (pendingImages.length === 0) {
      setTimeout(doPrint, 150);
      return;
    }

    let remaining = pendingImages.length;

    const imageFinished = () => {
      remaining -= 1;

      if (remaining <= 0) {
        setTimeout(doPrint, 150);
      }
    };

    pendingImages.forEach((img) => {
      img.addEventListener(
        'load',
        imageFinished,
        { once: true }
      );

      img.addEventListener(
        'error',
        imageFinished,
        { once: true }
      );
    });

  };


  if (printWindow.document.readyState === 'complete') {
    waitForImages();
  } else {
    printWindow.addEventListener(
      'load',
      waitForImages,
      { once: true }
    );
  }

}